import React from 'react';
import UrlParse from 'url-parse';
import _ from 'lodash';
import { validateUstEmail } from '../../../../helpers/redux_form';
import GeneralHelper from '../../../../helpers/general';
import { Card, Row, Col, Input, Button, Form, Select, Modal } from 'antd';
import OptionHelper from '../../../../helpers/Option';

class AdminBasicForm extends React.Component {
	formRef = React.createRef();
	state = {
		email: '',
		name: '',
		status: '',
		receive_controller_status_notification: false,
		loading: false,
		disableBtn: true,
		error: null,
		showDeleteModal: false
	};

	componentDidMount() {
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		const { admin } = this.props.pageProps;
		if (query.id && admin) {
			const initAdminValues = {
				email: admin.email,
				name: admin.name,
				status: admin.status,
				receive_controller_status_notification: admin.receive_controller_status_notification
			};
			this.setState(initAdminValues);

			this.formRef.current.setFieldsValue(initAdminValues);
		}
	}

	onBlur = () => {
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		if (!query.id) {
			if (validateUstEmail(this.state.email) === undefined) {
				this.setState({
					disableBtn: false,
					error: null
				});
			} else {
				this.setState({
					error: {
						content: 'Invalid Email Address'
					}
				});
			}
		}
	}

	componentDidUpdate(prevProps) {
		const { meta: prevMeta } = prevProps.pageProps;
		const { meta } = this.props.pageProps;
		if (meta && meta !== prevMeta) {
			const alertOptions = {
				type: meta.code === 200 ? 'success' : 'error',
				...(meta.code === 40399 && { timeout: 0 })
			};
			this.setState({ showDeleteModal: false });
			this.props.alert.show(meta.message, alertOptions);
			this.props.resetMeta();
		}
	}

	checkValues = () => {
		const { admin } = this.props.pageProps;
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		let isValueEqual = false;
		// enable/disable submit button if fields are empty or not empty
		if (query.id) {
			// disable submit button if values are same with prev/default values
			const keys = ['email', 'name', 'status'];
			const newPropArrObj = GeneralHelper.checkIfSameValues(keys, admin);
			const newStateArrObj = GeneralHelper.checkIfSameValues(keys, this.state);
			isValueEqual = _.isEqual(newStateArrObj, newPropArrObj);
		}
		const {
			email,
			name,
			status
		} = this.state;
		(email && name && status !== undefined) && !isValueEqual
			? this.setState({ disableBtn: false })
			: this.setState({ disableBtn: true });
	}

	onSubmit = async () => {
		this.setState({ loading: true });
		const { disableBtn } = this.state;
		if (!disableBtn) {
			const tempState = { ...this.state };
			// show red error borders of input
			const tempErrorObj = {
				email: tempState.email.match(/Invalid/g) ? true : false,
				name: tempState.name.match(/Invalid/g) ? true : false,
				status: tempState.status.match(/Invalid/g) ? true : false
			};

			if (Object.values(tempErrorObj).includes(true)) {
				this.setState({ disableBtn: true });
			} else {
				await this.props.onSubmit(this.state);
				this.setState({ disableBtn: true });
			}
			this.setState({ errors: tempErrorObj });
		}
		this.setState({ loading: false });
	}

	onDelete = async () => {
		this.props.deleteAdminById();
	}

	render() {
		const { email, name, status, loading, disableBtn, showDeleteModal  } = this.state;
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);

		return (
			<Card style={{ margin: '15px 15px 0', border: 0 }}>
				<Form
					ref={this.formRef}
					name="admin_form"
					layout="vertical"
					fields={[
						{
							email,
							name,
							status
						}
					]}
					onValuesChange={(_, allFields) => {
						this.formRef.current.setFieldsValue({name: GeneralHelper.toNormalCase(allFields.name)});

						this.setState({
							...allFields
						}, () => this.checkValues());
					}}
				>
					<Row
						type="flex"
						justify="center"
						align="middle"
					>
						<Col
							xl={7}
							lg={18}
							md={18}
							sm={24}
							xs={24}
						>
							<Form.Item
								name="name"
								label="Name"
								rules={[
									{ required: true, message: 'Please enter a name.' }
								]}
							>
								<Input maxLength={80}/>
							</Form.Item>
							<Form.Item
								name="email"
								label="Email Address"
								rules={[
									{ required: true, type: 'email', message: 'Please enter a valid ust email' },
									{
										validator(_, value) {
											if (!value || GeneralHelper.isUstEmail(value)) {
												return Promise.resolve();
											}
											return Promise.reject();
										}
									}
								]}
							>
								<Input maxLength={80}/>
							</Form.Item>
							<Form.Item
								name="status"
								label="Status"
								rules={[
									{ required: true, message: 'Please select a status.' }
								]}
							>
								<Select
									placeholder="Status"
									optionFilterProp="children"
									style={{ width: '100%' }}
								>
									{OptionHelper.adminStatus().map((option, index) => (
										<Select.Option
											key={index}
											value={option.value}
										>{option.text}</Select.Option>
									))}
								</Select>
							</Form.Item>
							<Row
								type="flex"
								justify={query.id ? 'space-between' : 'end'}
							>
								{query.id && (
									<Button
										disabled={loading}
										style={{ background: 'rgb(226, 0, 0)', color: '#fff' }}
										onClick={() => {
											this.setState({showDeleteModal: true});
										}}
									>
									Delete
									</Button>
								)}
								<Button
									disabled={loading || disableBtn || validateUstEmail(this.state.email)}
									style={{ background: '#003366', color: '#fff' }}
									onClick={this.onSubmit}
								>
									{!query.id ? 'Create' : 'Save'}
								</Button>
							</Row>
						</Col>
					</Row>
				</Form>
				{
					showDeleteModal && (
						<Modal
							title={`Delete Admin: ${GeneralHelper.truncateString(email, 40)}`}
							centered
							visible={showDeleteModal}
							onOk={() => this.onDelete()}
							onCancel={() => this.setState({ showDeleteModal: false })}
						>
							Are you sure you want to delete?
						</Modal>
					)
				}
			</Card>
		);
	}
}

export default AdminBasicForm;
